export const getEinvoiceOperators = () => {
  return (dispatch, getState, { api }) => {
    return api.getEinvoiceOperators().then(
      ({ result }) => {
        return {
          wasSuccessful: true,
          eInvoiceOperators: result.einvoiceOperators,
        };
      },
      (err) => ({ wasSuccessful: false }),
    );
  };
};
